import { makeStyles, createStyles, TextField, Typography, Theme } from "@material-ui/core";
import { RadioGroup } from "~components/Radio";

export type AmountFilterType = {
  type: "any" | "range";
  from?: number | null;
  to?: number | null;
};

export type AmountFilterProps = {
  filter?: AmountFilterType;
  setFilter?: (filter: { amount: AmountFilterType }) => void;
};

export const AmountFilter = ({ filter = { type: "any" }, setFilter }: AmountFilterProps) => {
  const classes = useStyles();

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = (event.target as HTMLInputElement).value as AmountFilterType["type"];
    if (typeof setFilter === "function") {
      setFilter({ amount: { ...filter, type: value, from: null, to: null } });
    }
  };

  const onChangeText = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    key: string,
  ) => {
    if (typeof setFilter === "function") {
      if (event.target.value.includes("-")) {
        setFilter({ amount: { ...filter, [key]: 0 } });
        return;
      }
      const value = parseFloat((event.target as HTMLInputElement).value);
      setFilter({
        amount: {
          ...filter,
          [key]: value,
        },
      });
    }
  };

  return (
    <div className={classes.root}>
      <RadioGroup
        id="range-switch"
        onChange={onChange}
        value={filter.type}
        items={[
          { value: "any", label: "Any amount" },
          { value: "range", label: "Amount range" },
        ]}
      />
      {filter.type === "range" && (
        <div className={classes.textfieldRoot}>
          <div className={classes.box}>
            <Typography className={classes.label}>From</Typography>
            <TextField
              className={classes.textField}
              InputProps={{
                classes: {
                  input: classes.input,
                },
                disableUnderline: true,
              }}
              value={filter.from || ""}
              placeholder="0.0"
              inputProps={{ step: 0.01, min: 0 }}
              type="number"
              variant="standard"
              onChange={(event) => onChangeText(event, "from")}
            />
          </div>
          <div className={classes.box}>
            <Typography className={classes.label}>To</Typography>
            <TextField
              className={classes.textField}
              InputProps={{
                classes: {
                  input: classes.input,
                },
                disableUnderline: true,
              }}
              value={filter.to || ""}
              placeholder="0.0"
              inputProps={{ step: 0.01, min: 0 }}
              type="number"
              variant="standard"
              onChange={(event) => onChangeText(event, "to")}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
    },
    textfieldRoot: {
      display: "flex",
      flexDirection: "row",
      paddingTop: theme.spacing(2),
    },
    box: {
      display: "flex",
      flexDirection: "column",
      marginRight: theme.spacing(2.5),
    },
    label: {
      fontSize: 16,
      color: theme.palette.dark.main,
      lineHeight: "normal",
      paddingBottom: theme.spacing(1.25),
    },
    textField: {
      boxShadow: "0 1px 1px 0 rgba(51, 91, 130, 0.12), 0 0 1px 0 rgba(10, 31, 68, 0.1)",
      backgroundColor: "white",
      borderRadius: 2,
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1),
    },
    input: {
      color: theme.palette.dark.main,
      fontSize: 14,
      lineHeight: 1.36,
      letterSpacing: "normal",
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  }),
);
